import { render, staticRenderFns } from "./FacebookSettingsCard.vue?vue&type=template&id=0b0328a2"
import script from "./FacebookSettingsCard.vue?vue&type=script&lang=ts"
export * from "./FacebookSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports